import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed } from 'vue';

import {
  DataTable,
  DataTableProps,
  Pagination,
  HelperViewStatus,
  HelperViewContextual
} from '@warrenbrasil/nebraska-web';
import { Filters } from './components/Filters';
import { OrderModal } from './components/OrderModal';
import { Portal } from '@/modules/common/components/Portal';

import { IOrdersPagination } from './types';
import { columns } from './ordersColumns';

import {
  getOrdersList,
  IOrders,
  IOrderListRequest,
  IOrdersListResponseFilters
} from '@/modules/wealth/services/wealth-orders';

interface Props {
  portfolioId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Orders',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
}



const isLoading = ref(true);
const hasError = ref(false);
const isEmpty = ref(false);
const orders = ref<IOrders[] | null>(null);
const pagination = ref<IOrdersPagination | null>(null);
const ordersFilters = ref<IOrdersListResponseFilters | null>(null);
const filters = ref<IOrderListRequest>({
  pageIndex: 1,
  pageSize: 10
});

const isOrderModalOpen = ref(false);
const orderApiId = ref('');

const status = computed(() => {
  if (isLoading.value) return DataTableProps.DataTableStatus.Loading;
  if (hasError.value) return DataTableProps.DataTableStatus.Error;
  return DataTableProps.DataTableStatus.Default;
});

const hasFilterSelected = computed(() => {
  return Boolean(filters.value.type || filters.value.period);
});

const isFilterDisabled = computed(() => {
  return isEmpty.value && !hasFilterSelected.value;
});

const showPagination = computed(() => {
  return (
    pagination.value && !hasError.value && !isLoading.value && !isEmpty.value
  );
});

const emptyStateHelperViewProps = computed(() => {
  if (hasFilterSelected.value) {
    return {
      icon: 'BB0040',
      type: 'info',
      title: 'Nenhuma ordem encontrada',
      description: 'Tente alterar os filtros'
    };
  }

  return {
    icon: 'BB0040',
    type: 'info',
    description: 'Você não possui ordens'
  };
});

async function fetchOrderList() {
  isLoading.value = true;
  hasError.value = false;
  try {
    const data = await getOrdersList(props.portfolioId, filters.value);

    pagination.value = {
      page: data.pageIndex,
      pageSize: data.pageSize,
      totalPages: data.totalPages
    };

    ordersFilters.value = data.filters;

    isEmpty.value = data.items.length === 0;

    orders.value = data.items;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function onFilterSelect(data: { filterKey: string; value: string }) {
  filters.value = {
    ...filters.value,
    [data.filterKey]: data.value,
    pageIndex: 1
  };

  await fetchOrderList();
}

async function handleOnSelectPage(value: number) {
  filters.value = {
    ...filters.value,
    pageIndex: value
  };

  await fetchOrderList();
}

function handleRowClick(order: IOrders) {
  orderApiId.value = order.apiId;
  toggleOrderModal();
}

function toggleOrderModal() {
  isOrderModalOpen.value = !isOrderModalOpen.value;
}

onMounted(async () => {
  await fetchOrderList();
});

return { __sfc: true,props, isLoading, hasError, isEmpty, orders, pagination, ordersFilters, filters, isOrderModalOpen, orderApiId, status, hasFilterSelected, isFilterDisabled, showPagination, emptyStateHelperViewProps, fetchOrderList, onFilterSelect, handleOnSelectPage, handleRowClick, toggleOrderModal, DataTable, Pagination, HelperViewStatus, HelperViewContextual, Filters, OrderModal, Portal, columns }
}

})